import { ArrowRight } from "lucide-react";

export function CTAFooter() {
  return (
    <footer id="contact" className="footer-shell">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-6 lg:px-8">
        <section className="footer-cta">
          <div>
            <p className="section-eyebrow">Ready when your screens are</p>
            <h2>Bring screens to life with one central signage dashboard.</h2>
            <p>
              Book a demo, contact sales, or log in to the dashboard if your team already has access.
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row lg:flex-col xl:flex-row">
            <a href="mailto:admin@pulsepanels.com?subject=PulsePanels%20demo" className="btn-primary btn-xl">
              Book a Demo
              <ArrowRight size={18} aria-hidden="true" />
            </a>
            <a href="mailto:admin@pulsepanels.com?subject=PulsePanels%20sales" className="btn-secondary-dark btn-xl">
              Contact Sales
            </a>
            <a href="https://app.pulsepanels.com" className="btn-secondary-dark btn-xl">
              Login
            </a>
          </div>
        </section>

        <div className="mt-10 flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <div>
            <img
              src="/brand/01_primary_horizontal_logo_transparent.svg"
              alt="PulsePanels"
              className="h-12 w-auto"
            />
            <p className="footer-description">
              PulsePanels helps teams manage, schedule, preview, and publish digital signage content from one dashboard.
            </p>
          </div>
          <div className="footer-links">
            <a href="#features">Features</a>
            <a href="#use-cases">Use Cases</a>
            <a href="#pricing">Pricing</a>
            <a href="#faq">FAQ</a>
            <a href="https://app.pulsepanels.com">Dashboard</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
